<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true">
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <!--
                <v-text-field
                        label="汇款单位"
                        :rules="rules.required"
                        v-model="item.drawee"
                />
                -->
                <v-combobox
                    label="汇款单位"
                    :rules="rules.required"
                    :items="claimedFundItems"
                    item-text="text"
                    item-value="dbid"
                    return-object
                    v-model="selectedClaimedFund"
                    @change="(v) => {
                       if(v.pznm){
                           item.drawee = v.dfdw;
                           const formattedDate = `${v.lkrq.slice(0, 4)}-${v.lkrq.slice(4, 6)}-${v.lkrq.slice(6, 8)}`;
                           item.paymentDate = formattedDate;
                           item.amount = v.je;
                           item.researchFund = v.je;
                           item.pznm = v.pznm;
                           item.flbh = v.flbh;
                           this.selectedClaimedFund = v.dfdw;
                           } else {
                              item.drawee = v
                              this.selectedClaimedFund = v;
                           }
                       }"
                />
              </v-flex>

              <v-flex xs6>
                <v-menu ref="paymentDateMenuRef"
                        lazy
                        :close-on-content-click="false"
                        v-model="paymentDateMenu"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        max-width="290px">
                  <v-text-field
                      slot="activator"
                      label="到款日期"
                      v-model="item.paymentDate"
                      :rules="rules.paymentDate"
                      hint="格式YYYY-MM-DD, 如：2018-10-01"
                      persistent-hint/>
                  <v-date-picker
                      v-model="paymentDate"
                      locale="zh-cn"
                      @change="nv => item.paymentDate= nv"/>
                </v-menu>
              </v-flex>

              <v-flex xs3>
                <v-select
                    label="到款次数"
                    :rules="rules.required"
                    :items="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]"
                    v-model="item.serialNum"/>
              </v-flex>

              <v-flex xs3>
                <v-select
                    label="到款性质"
                    :items="['新立', '追加']"
                    v-model="item.property"
                    :rules="rules.required"/>
              </v-flex>

              <v-flex xs5>
                <v-text-field
                    label="到款金额"
                    :rules="rules.amount"
                    v-model="item.amount"
                    hint="单位：元"
                    persistent-hint/>
              </v-flex>

              <v-flex xs5>
                <v-text-field
                    label="研究经费"
                    :rules="rules.researchFund"
                    v-model="item.researchFund"
                    hint="单位：元"
                    persistent-hint
                    @change="onFundChange"/>
              </v-flex>

              <v-flex xs12 sm2>
                <v-select
                    label="资金性质"
                    clearable
                    required
                    v-model="item.lkbz"
                    item-text="name"
                    item-value="dbid"
                    :items="lkbzItems"
                />
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                    label="到款拆分"
                    :rules="rules.required"
                    v-model="item.partitionId"
                    item-text="name"
                    item-value="dbid"
                    :items="partitionItems"
                    @change="onPartChange"/>
              </v-flex>

              <v-flex xs12>
                <v-data-table
                    class="dense"
                    :headers="headers"
                    :items="item.fundItems"
                    hide-actions
                    :loading="fundLoading">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.index + 1 }}</td>
                    <td>
                                          <span :style="`padding-left: ${props.item.level-1}em`">
                                          {{ props.item.name || props.item.partitionName }}
                                          </span>
                    </td>
                    <td>{{ props.item.percent | percent }}</td>
                    <td v-if="props.item.editable === 'T'">
                      <v-text-field
                          :key="props.item.dbid"
                          :rules="rules.sumCheck"
                          v-model="item.fundItems[props.index].amount"
                          @change="updatePercent(props.index)"
                      />
                    </td>
                    <td v-else>
                      {{ props.item.amount || '' }}
                    </td>
<!--                    <td>-->
<!--                      {{ props.item.cardName }}<br/>{{ props.item.cardNumber }} -->
<!--                    </td>-->
                  </template>
                </v-data-table>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                    label="备注"
                    v-model="item.note"
                    :rules="rules.note"
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import mixin from '@/mixin'

const baseURI = '/api/proj/fund/income';
const partURI = '/api/proj/fund/partition';
//const claimedFundURI = '/api/proj/fund/income/claimed'
const claimedFundURI = '/api/proj/fund/income/registed/uncheckd'

export default {
  mixins: [mixin.edit(baseURI)],
  props: ['value', 'uri', "dbid", 'projTypeId', 'default', 'leaderId', 'projId', 'deptId', 'adminDeptId'],
  components: {},

  data() {
    return {
      formValid: false,

      item: {},
      freshItem: {
        "projectId": null,
        "amount": null,
        "property": null,
        "partitionId": null,
        "drawee": null,
        "paymentDate": null,
        "userName": null,
        "timestamp": null,
        "serialNum": null,

        "researchFund": null,
        "pznm": null, // 凭证内码
        "flbh": null, // 分录编号

        "fundItems": []
      },

      headers: [
        {text: '#', sortable: false, value: 'rank', width: 18},
        {text: '拆分项目名称', sortable: false, value: 'name'},
        {text: '经费百分比', sortable: false, value: 'percent'},
        {text: '金额（元）', sortable: false, value: 'note', width: 150},
        // {text: '经费卡', sortable: false, value: 'name', width: 250},
      ],

      paymentDateMenu: false,
      paymentDate: null,

      partitionItems: [],

      fundLoading: false,

      claimedFundItems: [],

      selectedClaimedFund: null,

      lkbzItems: ["财政","非财政","学校配套"],


      /**
       * 验证规则
       */
      rules: {
        name: [
          v => !!v || '必填项。',
          v => (v && v.length <= 150) || '长度必须小于150个字符。'
        ],
        required: [
          v => !!v || '必填项。'
        ],
        amount: [
          v => !!v || '必填项。',
          v => (v && /^\d{1,10}?(\.[0-9][0-9]?)?$/ig.test(v)) || '填写数字，小数点后最多保留2位。',
          v => (v && Number(v) >= Number(this.item.researchFund || 0)) || "研究经费不能大于到款金额。"
        ],

        researchFund: [
          v => !!v || '必填项。',
          v => (v && /^\d{1,10}?(\.[0-9][0-9]?)?$/ig.test(v)) || '填写数字，小数点后最多保留2位。',
          v => (v && Number(v) <= Number(this.item.amount || 0)) || "研究经费不能大于到款金额。"
        ],

        sumCheck: [
          v => !!v || '必填项。',
          v => (v && /^\d{1,10}?(\.[0-9][0-9]?)?$/ig.test(v)) || '填写数字，小数点后最多保留2位。',
          v => (v && (this.item.fundItems.filter(v => v.leaf === 1).map(v => v.amount || 0)
              .reduce((s, v) => s + Number(v), 0)) <= Number(this.item.researchFund) + 0.01) || "分拆科目总额不能超过研究费。"
        ],

        wordCount: [
          v => !!v || '必填项。',
          v => (v && /^\d+(\.\d{1,2})?$/.test(v)) || '填写整数或小数,小数点后最多两位。'
        ],
        note: [v => (!v || v.length <= 255) || '长度必须小于255个字符。'],
        paymentDate: [
          v => !!v || "必填项。",
          v => window.xutil.regexpDate().test(v) || '日期格式错误'
        ],
      }
    }
  },

  watch: {
    projTypeId(v) {
      if (!v) return;
      this.axios
          .get(partURI, {
                params: {limit: 65535, typeId: v, sort: 'rank.asc'}
              }
          )
          .then(
              rsp => this.partitionItems = rsp.data.items
          )
    }
  },

  created() {
    this.axios.get(`${claimedFundURI}`).then(rsp => {
      this.claimedFundItems = rsp.data.map((v) => {
        v.text = `¥${v.je}元 / ${v.dfdw} / ${v.zy}`;
        return v;
      })
      window.console.log(this.claimedFundItems)
    })

  },

  methods: {
    onPartChange(v, ov) {
      // window.console.log(`in onPartChange， v: ${v}, ov:${ov}`);

      const params = {
        "projId": this.projId,
        "deptId": this.deptId,
        "adminDeptId": this.adminDeptId
      };
      // 新建
      if (!ov && v && this.item.fundItems.length === 0) {
        // window.console.log(`in onPartChange， new`);
        this.axios.get(`${partURI}/detail/${v}`, {"params": params})
            .then(
                rsp =>
                    this.top2down(v, (this.item.researchFund || 0),
                        rsp.data.map(v => {
                              v.partitionId = v.dbid;
                              v.partitionParentId = v.parentId;
                              return v
                            }
                        )
                    )
            )
      }

      // 编辑时读回远程数据
      if (!ov && v && this.item.fundItems.length > 0) {
        // window.console.log(`in onPartChange， restore`);

        this.axios.get(`${partURI}/detail/${v}`, {"params": params})
            .then(
                rsp => this.top2down(v, (this.item.researchFund || 0),
                    rsp.data.map(v => {
                          v.partitionId = v.dbid;
                          v.partitionParentId = v.parentId;
                          return v
                        }
                    )
                )
            )
      }

      // 编辑过程中修改
      if (ov && v) {
        // window.console.log(`in onPartChange，modify`);

        this.axios.get(`${partURI}/detail/${v}`)
            .then(
                rsp => this.top2down(v, (this.item.researchFund || 0),
                    rsp.data.map(v => {
                          v.partitionId = v.dbid;
                          v.partitionParentId = v.parentId;
                          return v
                        }
                    )
                )
            )
      }

    },

    onFundChange(nv) {
      // window.console.log("in onFundChange");

      this.top2down(this.item.partitionId, nv, this.item.fundItems);
    },

    top2down(partId, amount, tplItems) {
      if (!partId) return;

      const am = {}; // 父节点经费
      am[partId] = Number(amount);

      this.item.fundItems = tplItems.map(
          v => {
            // 手动输入项目
            if (v.editable === 'T') {
              // 第一次计算金额（比例到金额）
              if (v.amount === undefined) {
                v.amount = Math.round(v.percent * am[v.partitionParentId]) / 100;
              }
              // 更新计算（金额到比例）
              else {
                v.percent = Math.round(Number(v.amount) / am[v.partitionParentId] * 100 * 100) / 100;
              }
            }
            // 自动计算项目
            else {
              v.amount = Math.round(v.percent * am[v.partitionParentId]) / 100;
            }

            // 保存父级节点金额
            am[v.partitionId] = v.amount;

            return v;
          }
      );

      // force to validate other inputs
      this.$refs.formRef.validate();
    },

    // 从手动输入的值更新百分比
    updatePercent(idx) {
      this.item.fundItems[idx].percent =
          Number(this.item.fundItems[idx].amount) * 100 / Number(this.item.researchFund);

      // force to validate other inputs
      this.$refs.formRef.validate();
    },

    // mixin 加载数据后调用
    // afterGetData(data) {
    // },

    beforeSendData(data) {
      //console.log("in beforeSendData");
      data.typeId = this.typeId;
      data.disabled = 'F';
    }
  }
}
</script>
